import React from "react"
import { ToastContainer } from "react-toastify"
import { GatsbyBrowser } from "gatsby"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { TagManagerContextProvider } from "../contexts/tagManager"
import { FirebaseContextProvider } from "../contexts/firebase"
import { AuthUserContextProvider } from "../contexts/auth/user"
import { ApiProvider } from "../contexts/api"

import "../global.css"

const queryClient = new QueryClient()

const wrapRootElement: GatsbyBrowser["wrapRootElement"] = ({ element }) => {
  return (
    <React.Fragment>
      <QueryClientProvider client={queryClient}>
        <TagManagerContextProvider>
          <FirebaseContextProvider>
            <AuthUserContextProvider>
              <ApiProvider>{element}</ApiProvider>
            </AuthUserContextProvider>
          </FirebaseContextProvider>
        </TagManagerContextProvider>
      </QueryClientProvider>
      <ToastContainer />
    </React.Fragment>
  )
}

export default wrapRootElement
